import { SpcResult } from '../../types/spc.js';
import { NUM_SPC_CHECKS } from '../../utils/spcConstants.js';


// Aggregate spc check results from multiple measurements of a position into single result per rule
export function aggregateSpcChecks(
    spcResults: SpcResult[],
): SpcResult {
    const aggregated = [...Array(NUM_SPC_CHECKS)].map(
        (_, idx) => {
            const spcs = spcResults.map(it => it[idx]);
            const anyTrue = spcs.some(Boolean);
            const allNull = !anyTrue && spcs.every(it => it === null);
            return allNull ? null : anyTrue;
        }) as SpcResult;
    return aggregated;
}
